var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 110,
    viewBox: "0 0 81 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20H65.5V30H75.5V10C75.5 4.5 71 0.05 65.5 0.05L15.5 0C10 0 5.5 4.5 5.5 10V30H15.5V20ZM57.55 77.95L80.5 55L57.55 32.05L50.5 39.15L66.35 55L50.5 70.85L57.55 77.95ZM30.5 70.85L14.65 55L30.5 39.15L23.45 32.05L0.5 55L23.45 77.95L30.5 70.85ZM65.5 90H15.5V80H5.5V100C5.5 105.5 10 110 15.5 110H65.5C71 110 75.5 105.5 75.5 100V80H65.5V90Z",
    fill: "#368AC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20H65.5V30H75.5V10C75.5 4.5 71 0.05 65.5 0.05L15.5 0C10 0 5.5 4.5 5.5 10V30H15.5V20ZM57.55 77.95L80.5 55L57.55 32.05L50.5 39.15L66.35 55L50.5 70.85L57.55 77.95ZM30.5 70.85L14.65 55L30.5 39.15L23.45 32.05L0.5 55L23.45 77.95L30.5 70.85ZM65.5 90H15.5V80H5.5V100C5.5 105.5 10 110 15.5 110H65.5C71 110 75.5 105.5 75.5 100V80H65.5V90Z",
    fill: "url(#paint0_linear_3133_237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3133_237",
    x1: 0.5,
    y1: 55,
    x2: 80.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneVector);
export default __webpack_public_path__ + "static/media/phoneVector.c1e71ea2361da6d1b8f86055c4d6c7ab.svg";
export { ForwardRef as ReactComponent };